import { OBJECT_TYPE } from "../../constants/canvasConstants";
import { AddImageOptions } from "../../types/imageTypes";
import { useDispatchBaseEvent, useSubscribeToBaseEvent } from "../useDispatchBaseEvent";

export const ADD_OBJECT_EVENT_NAME = "useAddObjectEvent";

type ObjectType = keyof typeof OBJECT_TYPE;
export type AddObjectEvent = {
  type: typeof ADD_OBJECT_EVENT_NAME;
  payload:
    | {
        type: Extract<ObjectType, "shape" | "text">;
      }
    | {
        type: Extract<ObjectType, "image">;
        data: AddImageOptions;
      };
};

export function useDispatchAddObjectEvent() {
  return useDispatchBaseEvent<AddObjectEvent>(ADD_OBJECT_EVENT_NAME);
}

export function useSubscribeToAddObjectEvent(handler: (payload: AddObjectEvent["payload"]) => void) {
  useSubscribeToBaseEvent<AddObjectEvent>(ADD_OBJECT_EVENT_NAME, handler);
}
